import React from 'react';

import { Breadcrumb } from 'antd';
import styled from 'styled-components';

import { useAppSelector } from '../../../store/hook';
import { useIncentivesContext } from '../IncentivesContext';

const StyledBreadcrumb = styled(Breadcrumb)`
  span {
    color: var(--text-primary);

    &.fixed {
      color: var(--text-secondary);
    }
  }
`;

const IncentivesHeaderBreadcrumbs = () => {
  const { selectedCompany } = useAppSelector((state) => state.global);

  return (
    <StyledBreadcrumb
      items={[
        {
          title: selectedCompany?.name,
        },
        {
          className: 'fixed',
          title: 'Company',
        },
      ]}
      separator="·"
    />
  );
};

export default IncentivesHeaderBreadcrumbs;
